import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAskPanel } from "@/components/ai/AskPanelContext";

/** Old /ask links (bookmarks, ?q=, ?report=): open the Ask AI panel on My Day instead */
export function AskRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { openAsk } = useAskPanel();
  useEffect(() => {
    openAsk({ q: params.get("q") || undefined, report: params.get("report") || undefined });
    navigate("/dashboard", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
